import { render } from "./location.vue?vue&type=template&id=1931c5a6&scoped=true"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"

import "./location.vue?vue&type=style&index=0&id=1931c5a6&scoped=true&lang=css"
import "./location.vue?vue&type=style&index=1&id=1931c5a6&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1931c5a6"]])

export default __exports__